export const heroData = {
  label: "PRIVACY POLICY",
  title: "Privacy Policy",
  subtitle:
    "AIRDOA considers the protection of your personal information a key responsibility and strives to ensure you can use our services with confidence.",
  image:
    "https://readdy.ai/api/search-image?query=Serene%20modern%20office%20interior%20with%20soft%20natural%20light%2C%20clean%20minimal%20desk%20with%20document%2C%20calming%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20gold%20color%20accents%2C%20no%20text%2C%20professional%20corporate%20photography%20style&width=1920&height=600&seq=privacyhero01&orientation=landscape",
};

export const summaryText =
  "AIRDOA (hereinafter 'the Company') considers it a social responsibility to handle and protect customers' personal information appropriately in providing helicopter cruise services. This Privacy Policy sets out the types of personal information we collect, the purposes for which it is used, and how it is managed.";

export const sections = [
  {
    title: "Definition of Personal Information",
    content:
      "In this Privacy Policy, 'personal information' refers to information relating to a living individual that can be used to identify a specific individual by name, date of birth, or other description contained in the information.",
  },
  {
    title: "Collection of Personal Information",
    content:
      "The Company may collect customers' personal information for the following purposes:\n\n- Inquiry form (name, email address, phone number, inquiry details)\n- Reservation form (name, email address, phone number, passenger information, emergency contact)\n- Gift ticket purchase (purchaser information, shipping address, recipient information)\n- Customer surveys (age group, visit purpose, etc., including statistical information that does not identify individuals)",
  },
  {
    title: "Purpose of Use",
    content:
      "Collected personal information will be used within the scope of the following purposes:\n\n1. Responding to inquiries and processing reservations\n2. Important service-related communications (flight cancellation notices, schedule changes, etc.)\n3. Information about campaigns and new services (only with consent)\n4. Preparing surveys and statistical data (only in non-identifiable form)\n5. Compliance with laws and guidelines",
  },
  {
    title: "Provision to Third Parties",
    content:
      "The Company will not provide customers' personal information to third parties except in the following cases:\n\n- When the individual has given consent\n- When required to disclose by law\n- When necessary to protect life, body, or property of a person\n- In connection with a business succession (merger, company split, business transfer, etc.)",
  },
  {
    title: "Security Management",
    content:
      "The Company takes the following measures to prevent the leakage, loss, or damage of personal information:\n\n- Access control management and employee training\n- Measures against unauthorized access to servers and databases\n- Protection of data transmission via SSL encryption\n- Establishment of internal regulations on personal information handling",
  },
  {
    title: "Use of Cookies and Analytics Tools",
    content:
      "This website may use cookies and the following analytics tools for the purpose of improving services and enhancing user experience:\n\n- Google Analytics: Used to statistically understand site usage and improve our services\n- Advertising cookies: Used by third-party advertising networks to display appropriate advertisements (opt-out available)\n\nYou can disable cookies in your browser settings, but some services may not function properly as a result.",
  },
  {
    title: "Disclosure, Correction & Deletion",
    content:
      "Customers have the right to request disclosure, correction, addition, deletion, or suspension of use of personal information held by the Company. To make a request, please contact us via the inquiry page or at the details below:\n\n[Email] info@airdoa.jp\n[TEL] 0120-XXX-XXX (Weekdays 10:00–18:00)\n\n*We may ask you to verify your identity.",
  },
  {
    title: "Changes to This Policy",
    content:
      "The Company may revise this Privacy Policy as necessary. For significant changes, we will notify users on this website and, where deemed important, via the registered email address.",
  },
  {
    title: "Contact",
    content:
      "For inquiries regarding this Privacy Policy, please contact us at:\n\n- Inquiry form: /contact\n- Email: info@airdoa.jp\n- Phone: 0120-XXX-XXX (Weekdays 10:00–18:00)",
  },
];

export const enactedDate = "May 1, 2026";
export const revisedDate = "May 1, 2026";
